import '@ui5/webcomponents/dist/Button'; // Import UI5 Button component

const ButtonPositive = (props) => {
  // Destructure props to ensure only relevant props are passed to the UI5 Button component
  const { children, ...rest } = props;

  return (
    <ui5-button design="Positive" {...rest}>
      {children}
    </ui5-button>
  );
};

export default ButtonPositive;

